import { string, object } from "prop-types";

import QaWildcard from "../QaWildcard/QaWildcard.jsx";
import CommentsInterface from "../CommentsInterface/CommentsInterface.jsx";

const propTypes = {
  backLink: string,
  title: string.isRequired,
  body: string.isRequired,
  authorName: string,
  dictionary: object.isRequired,
};

const PerspectivesThread = (props) => {
  const { backLink, title, body, authorName, dictionary } = props;

  return (
    <section className="perspectives-thread container">
      <QaWildcard
        backLink={backLink}
        title={title}
        text={body}
        authors={[authorName]}
        authorLabel="Written by"
      />
      <CommentsInterface {...props} />
    </section>
  );
};

PerspectivesThread.propTypes = propTypes;
export default PerspectivesThread;
